module.exports = __webpack_public_path__ + "img/features-1.11b238d7.png";